// @flow
import { PRODUCT_SIGNATURES } from 'Client/cms/toolkit/constants';
import { ProductSignaturesLine } from 'Components/lines/product-signatures-line/ProductSignaturesLine.jsx';

export const productSignaturesDescriptor = {
  name: PRODUCT_SIGNATURES,
  component: ProductSignaturesLine,
};
